var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocalAtm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_495_21646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 29.17,
    height: 29.17,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_495_21646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9775 20.0545H15.1929V18.8391H16.6888C16.9553 18.8391 17.1777 18.7499 17.3561 18.5714C17.5346 18.393 17.6238 18.1706 17.6238 17.9042V14.9123C17.6238 14.6459 17.5346 14.4235 17.3561 14.2451C17.1777 14.0666 16.9553 13.9774 16.6888 13.9774H12.7621V11.5466H17.6238V10.3312H15.1929V9.11575H13.9775V10.3312H12.4816C12.2152 10.3312 11.9927 10.4204 11.8143 10.5988C11.6359 10.7772 11.5467 10.9996 11.5467 11.2661V14.2579C11.5467 14.5244 11.6359 14.7468 11.8143 14.9252C11.9927 15.1036 12.2152 15.1928 12.4816 15.1928H16.4084V17.6237H11.5467V18.8391H13.9775V20.0545ZM5.60984 23.093C5.05044 23.093 4.58337 22.9057 4.20861 22.5309C3.83386 22.1562 3.64648 21.6891 3.64648 21.1297V8.04056C3.64648 7.48117 3.83386 7.01409 4.20861 6.63934C4.58337 6.26459 5.05044 6.07721 5.60984 6.07721H23.5606C24.12 6.07721 24.5871 6.26459 24.9619 6.63934C25.3366 7.01409 25.524 7.48117 25.524 8.04056V21.1297C25.524 21.6891 25.3366 22.1562 24.9619 22.5309C24.5871 22.9057 24.12 23.093 23.5606 23.093H5.60984ZM5.60984 21.8776H23.5606C23.7476 21.8776 23.919 21.7997 24.0748 21.6439C24.2307 21.4881 24.3086 21.3167 24.3086 21.1297V8.04056C24.3086 7.85359 24.2307 7.68219 24.0748 7.52635C23.919 7.37053 23.7476 7.29263 23.5606 7.29263H5.60984C5.42287 7.29263 5.25146 7.37053 5.09563 7.52635C4.93981 7.68219 4.8619 7.85359 4.8619 8.04056V21.1297C4.8619 21.3167 4.93981 21.4881 5.09563 21.6439C5.25146 21.7997 5.42287 21.8776 5.60984 21.8776Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalAtm);
export default __webpack_public_path__ + "static/media/local-atm.af58fdd3d79b7186f074fb9be054238d.svg";
export { ForwardRef as ReactComponent };